const cookieNotification = {
    message: 'This site uses cookies',
    description: 'More',
    button: 'Ok',
};

export default cookieNotification;
